import React from 'react';

import { Box } from '@wds/box';
import { Tabs, Tab } from '@wds/tabs';
import { PageHeader } from '@wds/page-header';
import { createMemoStyles } from '@wds/styles';

import PropTypes from 'prop-types';

const ApplyPageHeader = (props) => {
	const {
		headerTitle, tabs, selectedTab, handleTabChange, tabErrors,
	} = props;

	const useStyles = createMemoStyles((theme) => (
		{ bottomBorder: { borderBottom: `1px solid ${theme.palette.border.main}` } }
	));

	const { bottomBorder } = useStyles();

	return (
		<Box>
			<Box className={bottomBorder}>
				<div style={{ maxHeight: '65px' }}>
					<PageHeader title={headerTitle} />
				</div>
				{tabs && (
					<Tabs value={selectedTab} onChange={(event) => handleTabChange(event.currentTarget.value)}>
						{Object.keys(tabs).map((tab) => {
							const tabData = tabs[tab];
							return (
								<Tab
									key={tabData.id}
									selected={tabData.id === selectedTab}
									title={tabData.label}
									value={tabData.id}
									indicator={tabErrors?.[tabData.id] ? 'error' : undefined}
								/>
							);
						})}
					</Tabs>
				)}
			</Box>
		</Box>
	);
};

ApplyPageHeader.propTypes = {
	headerTitle: PropTypes.string.isRequired,
	tabs: PropTypes.object.isRequired,
	selectedTab: PropTypes.string.isRequired,
	handleTabChange: PropTypes.func.isRequired,
	tabErrors: PropTypes.object,
};
ApplyPageHeader.defaultProps = { tabErrors: {} };
export default ApplyPageHeader;
